/** @format */

import Translator from './Translator.js';
import { datesOnPackages } from './dateTranslations.js';
import { dateSelectors } from './datesToLower.js';
import { frenchRegexTranslations } from './regexTranslations.js';
import { onEventOnPackages } from './onEventTranslations.js';
import { stringTranslations, priceLabelTranslations } from './stringTranslations.js';
import { toLower, reorderPrices, removePastTimesButtons } from './helpers.js';

const translator = new Translator();

const apiRequestTranslations = [
    {
        endpoint: '/events/ticketselector',
        callback: (response) => {
            if (response.isSuccessful && response?.html.length) {
                reorderPrices();
                translator
                    .string(stringTranslations, ['.modal-btn-cancel', '.modal-btn-confirm', '.tn-required-field', '.sr-only'])
                    .replace(priceLabelTranslations, ['.tn-flex-in-progress-package__section-contents', '.tn-flex-cart__selected-pricetypes', '.tn-ticket-selector__pricetype-name', '.tn-cart-item-detail__list-item--pricetype'])
                    .dates(datesOnPackages)
                    .onEvent(onEventOnPackages)

                // Remove passed times from time pickers.
                removePastTimesButtons('.tn-ticket-selector__controls-container');

                // Update dates that need to be lower case and french regex.
                if (translator.to() === 'fr') {
                    translator.regex(frenchRegexTranslations);
                    toLower(dateSelectors);
                }
            }
        }
    }
]

export { apiRequestTranslations };
